<template>
  <p v-bind="$attrs" class="text-h6">
    <slot></slot>
  </p>
</template>

<script>
export default {
}
</script>
